import { useCallback, useState } from 'react'

type useIframeProps = {
  origin: string
  src: string
  title?: string
}

const useIframe = ({ origin, src, title }: useIframeProps) => {
  const [height, setHeight] = useState('100vh')

  const receiveMessage = useCallback(
    (event: MessageEvent) => {
      try {
        const expectedOrigin = new URL(origin).origin
        if (event.origin !== expectedOrigin) return
      } catch {
        if (event.origin !== origin.replace(/\/$/g, '')) return
      }

      const { height: iframeHeight } = event.data

      const parsedIframeHeight = Number(iframeHeight)
      if (!Number.isFinite(parsedIframeHeight)) return

      const newHeight = `${Math.ceil(parsedIframeHeight + 50)}px`
      const prevHeight = `${parsedIframeHeight}px`

      setHeight((prev) => (prev !== prevHeight ? newHeight : prev))
    },
    [origin]
  )

  return {
    receiveMessage,
    iframeAttributes: {
      src,
      style: {
        border: 'none',
        display: 'block',
        width: '100%',
        height,
        padding: 0,
        margin: 0
      },
      title
    }
  }
}

export default useIframe
